import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import AtMentionFormat from './AtMentionFormat';
import HashMentionFormat from './HashMentionFormat';
export default class MentionFormats {
  constructor() {
    _defineProperty(this, "formats", [new AtMentionFormat(), new HashMentionFormat()]);
  }
  get(symbol) {
    var _this$formats$find;
    return (_this$formats$find = this.formats.find(f => f.trigger() === symbol)) != null ? _this$formats$find : null;
  }
  mentionable(type) {
    for (const format of this.formats) {
      const mentionable = format.getMentionable(type);
      if (mentionable) return mentionable;
    }
    return null;
  }
  extend(format) {
    this.formats.push(new format());
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/formats/MentionFormats', MentionFormats);